// ----------------------------------------------------------------------

export const account = {
  displayName: "Suman Saha",
  photoURL: "/assets/images/avatars/avatar_25.jpg",
};
